const Stacks = {
  Expand: 'expand',
  Zero: 'zero',
  Silhouette: 'silhouette',
  Wiggle: 'wiggle',
  Divergent: 'divergent',
};
export default Stacks;
